export default __webpack_public_path__ + "static/open-positions-background-63bfec25cc605b92f47f3eea89e6bc97.jpg";